import uuid from 'react-uuid';

export default function useRandomId(): string {
    const uid = uuid();

    return uid;
}
